<template>
    <div
        id="list-lineHierarchyTypes-component"
        class="w-full h-full flex flex-col"
    >
        <custom-simple-select
            v-model="option"
            class="w-full"
            label="Tipo"
            :options="lineHierarchyTypeOptions"
            :disabled="!enabled"
            @change="onInput"
        />
    </div>
</template>

<script>
import { lineHierarchyTypes } from "@/common/fields/line-hierarchy-types";

import CustomSimpleSelect from "@/components/utils/CustomSimpleSelect.vue";

export default {
    name: "LineHierarchyTypeSelector",
    components: { CustomSimpleSelect },
    model: {
        prop: "itemCurrent",
        event: "change"
    },
    props: {
        itemCurrent: {
            default: () => "line",
            type: String,
            require: true
        },
        enabled: {
            default: () => true,
            type: Boolean,
            required: false
        }
    },
    emits: ["change"],
    data: () => ({
        option: ""
    }),
    computed: {
        lineHierarchyTypeOptions() {
            return Object.entries(lineHierarchyTypes).map(([key, value]) => ({
                label: `${value}`,
                value: key
            }));
        }
    },
    watch: {
        itemCurrent(value) {
            this.setInput(value);
        }
    },
    mounted() {
        this.setInput(this.itemCurrent);
    },
    methods: {
        onInput() {
            this.$emit("change", this.option);
        },
        setInput(value) {
            this.option = value;
        }
    }
};
</script>
